<!--
 * @Author: 曹捷
 * @Date: 2022-01-10 10:02:05
 * @LastEditors: 曹捷
 * @LastEditTime: 2022-01-14 14:06:31
 * @Description: 设备使用率
-->
<template>
  <div class="charts" ref="chartContainer"></div>
</template>

<script>
import { onMounted, toRefs, reactive } from 'vue'
import dayjs from 'dayjs'
export default {
  setup () {
    let _data = reactive({
      chartContainer: null
    })
    let _methods = {
      initChart () {
        const { Pie } = G2Plot;
        let data = [
          { type: '使用中', value: 898 },
          { type: '未使用', value: 123 },
        ]
        const piePlot = new Pie(_data.chartContainer, {
          appendPadding: 20,
          data,
          angleField: 'value',
          colorField: 'type',
          radius: 1,
          innerRadius: 0.75,
          label: {
            content: '',
          },
          legend: false,
          interactions: [{ type: 'element-selected' }, { type: 'element-active' }],
          statistic: {
            title: {
              content: '已接入设备数/总数',
              style: {
                fontSize: 14
              }
            },
            content: {
              style: {
                color: '#1DB954',
                whiteSpace: 'pre-wrap',
                overflow: 'hidden',
                fontSize: 48,
                textOverflow: 'ellipsis',
              },
              formatter (info) {
                return `${Math.ceil(data[0].value / (data[0].value + data[1].value) * 100)}%`
              },
            },
          },
          color: ['#2E77D0', '#BDBDBD'],
        });
        piePlot.render();
      }
    }
    onMounted(() => {
      _methods.initChart()
    })
    return {
      ...toRefs(_data),
      ..._methods
    }
  }
}
</script>

<style lang="less">
.charts {
  width: 100%;
  height: 100%;
}
</style>